import {t} from '@/core/utils/t'
import {documentComponent} from '@/core'

export const doc = documentComponent({
  name: 'GoogleButton',
  description: 'Login with google button',
  categories: ['element', 'button'],
  props: t.object({}),
  examples: { },
  todo: [ ],
})
